<template>
  <footer class="footer ff">
    <div class="container side">
      <div class="copyright text-center txt">
        &copy; {{ new Date().getFullYear() }}
        <a
          href="https://www.cleato.com/"
          target="_blank"
        >Cleato (pvt) ltd</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
.ff {
  background-color: #e4e4e4 !important;
  padding: unset !important;
}
.side {
  text-align: right !important;
  display: block !important;
}
.txt {
  color: #6c757d;
  font-weight: 500;
}
.txt a {
  color: #f68930 !important;
}
</style>
